var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "card search-card" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("ValidationObserver", {
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit }) {
                    return [
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col-sm-12 col-md-3" }, [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("招募期限"),
                              ]),
                              _c("date-picker", {
                                staticClass: "w-100",
                                attrs: {
                                  type: "date",
                                  range: "",
                                  placeholder: "YYYY-MM-DD~YYYY-MM-DD",
                                },
                                model: {
                                  value: _vm.dueDateRange,
                                  callback: function ($$v) {
                                    _vm.dueDateRange = $$v
                                  },
                                  expression: "dueDateRange",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "col-sm-12 col-md-3" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "label",
                              { attrs: { for: "ManpowerDemandNo" } },
                              [_vm._v("職缺編號")]
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.opening.ManpowerDemandNo,
                                  expression: "opening.ManpowerDemandNo",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "ManpowerDemandNo",
                                placeholder: "請輸入關鍵字",
                              },
                              domProps: { value: _vm.opening.ManpowerDemandNo },
                              on: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.getOpening({
                                    page: 1,
                                    perPage: _vm.tableInfo.perPage,
                                  })
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.opening,
                                    "ManpowerDemandNo",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("div", { staticClass: "col-sm-12 col-md-3" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "label",
                              { attrs: { for: "ManpowerDemandName" } },
                              [_vm._v("職缺名稱")]
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.opening.ManpowerDemandName,
                                  expression: "opening.ManpowerDemandName",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "ManpowerDemandName",
                                placeholder: "請輸入關鍵字",
                              },
                              domProps: {
                                value: _vm.opening.ManpowerDemandName,
                              },
                              on: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.getOpening({
                                    page: 1,
                                    perPage: _vm.tableInfo.perPage,
                                  })
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.opening,
                                    "ManpowerDemandName",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("div", { staticClass: "col-sm-12 col-md-3" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(_vm._s(_vm.i18n("Position.PositionName"))),
                            ]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.opening.PositionName,
                                  expression: "opening.PositionName",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "PositionName",
                                placeholder: "請輸入關鍵字",
                              },
                              domProps: { value: _vm.opening.PositionName },
                              on: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.getOpening({
                                    page: 1,
                                    perPage: _vm.tableInfo.perPage,
                                  })
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.opening,
                                    "PositionName",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("div", { staticClass: "col-sm-12 col-md-3" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "" } }, [
                              _vm._v(_vm._s(_vm.i18n("Basic.ApplyDepartment"))),
                            ]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.opening.DemandDepartment,
                                  expression: "opening.DemandDepartment",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "DemandDepartment",
                                placeholder: "請輸入關鍵字",
                              },
                              domProps: { value: _vm.opening.DemandDepartment },
                              on: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.getOpening({
                                    page: 1,
                                    perPage: _vm.tableInfo.perPage,
                                  })
                                },
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.opening,
                                    "DemandDepartment",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("div", { staticClass: "col-sm-12 col-md-3" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "Applicant" } }, [
                              _vm._v(_vm._s(_vm.i18n("Basic.ApplyUser"))),
                            ]),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.opening.Applicant,
                                  expression: "opening.Applicant",
                                  modifiers: { trim: true },
                                },
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                id: "Applicant",
                                placeholder: "請輸入關鍵字",
                              },
                              domProps: { value: _vm.opening.Applicant },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.opening,
                                    "Applicant",
                                    $event.target.value.trim()
                                  )
                                },
                                blur: function ($event) {
                                  return _vm.$forceUpdate()
                                },
                              },
                            }),
                          ]),
                        ]),
                        _c("div", { staticClass: "col-sm-12 col-md-3" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-search",
                              staticStyle: {
                                "margin-top": "30px",
                                "margin-left": "10px",
                              },
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  handleSubmit(
                                    _vm.getOpening({
                                      page: 1,
                                      perPage: _vm.tableInfo.perPage,
                                    })
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.i18n("Buttons.Search")) + " "
                              ),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              staticStyle: {
                                "margin-top": "30px",
                                "margin-left": "10px",
                              },
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  _vm.opening = {
                                    ManpowerDemandNo: null,
                                    PositionName: null,
                                    DemandDepartment: null,
                                    Applicant: null,
                                    RecruitmentStatus: null,
                                    RecruitmentDeadlineStart: null,
                                    RecruitmentDeadlineEnd: null,
                                  }
                                  _vm.dueDateRange = []
                                },
                              },
                            },
                            [_vm._v(" 清除 ")]
                          ),
                        ]),
                      ]),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "yahome-table-wrap" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.rows, height: "450px" },
              on: { "sort-change": _vm.sortChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "ManpowerDemandName",
                  label: "職缺名稱",
                  width: "350",
                  "header-align": "center",
                  fixed: "",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "light", placement: "top" },
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _vm._v(
                                  " 招募期限：" +
                                    _vm._s(
                                      _vm.$common.dateFormatter(
                                        props.row.RecruitmentDeadline
                                      )
                                    )
                                ),
                                _c("br"),
                                _vm._v(
                                  " 需求單：" +
                                    _vm._s(props.row.ManpowerDemandNo)
                                ),
                                _c("br"),
                                _vm._v(
                                  _vm._s(props.row.ManpowerDemandName) + " "
                                ),
                              ]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-sm btn-file",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.viewDemand(
                                      props.row.ManpowerDemandNo
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "block",
                                      "text-overflow": "ellipsis",
                                      overflow: "hidden",
                                      width: "293px",
                                      "white-space": "nowrap",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(props.row.ManpowerDemandName) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "header-align": "center",
                  align: "center",
                  width: "160",
                  prop: "DemandNumber",
                  label: _vm.i18n("DemandApply.DemandNumber"),
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "header-align": "center",
                  align: "center",
                  prop: "ApplicantTime",
                  label: _vm.i18n("Basic.ApplyDate"),
                  sortable: "custom",
                  width: "220",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$common.dateFormatter(props.row.ApplicantTime)
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "header-align": "center",
                  align: "center",
                  prop: "DemandDepartment",
                  "min-width": "180",
                  label: _vm.i18n("Basic.ApplyDepartment"),
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "header-align": "center",
                  align: "center",
                  prop: "Applicant",
                  "min-width": "180",
                  label: _vm.i18n("Basic.ApplyUser"),
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  "header-align": "center",
                  width: "380",
                  prop: "recruitStatus",
                  label: _vm.i18n("Basic.RecruitStatus"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c("div", { staticClass: "recruit-status" }, [
                          _c(
                            "button",
                            {
                              staticClass: "status resume_list",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.goResumeList(props.row)
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.i18n("StatusBar.ResumeList"))
                                ),
                              ]),
                              _c("div", { staticClass: "count" }, [
                                _vm._v(_vm._s(props.row.ResumeCount)),
                              ]),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "status interviewing",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.goInterviewing(props.row)
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.i18n("StatusBar.WaitInterview"))
                                ),
                              ]),
                              _c("div", { staticClass: "count" }, [
                                _vm._v(_vm._s(props.row.WaitInterviewCount)),
                              ]),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "status interviewed",
                              on: {
                                click: function ($event) {
                                  return _vm.goInterviewed(props.row)
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.i18n("StatusBar.Interviewed"))
                                ),
                              ]),
                              _c("div", { staticClass: "count" }, [
                                _vm._v(_vm._s(props.row.InterviewedCount)),
                              ]),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "status not_arrived",
                              on: {
                                click: function ($event) {
                                  return _vm.goDeclineInterview(props.row)
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.i18n("StatusBar.DeclineInterview"))
                                ),
                              ]),
                              _c("div", { staticClass: "count" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(props.row.InterviewNotArrivedCount) +
                                    " "
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "status interview_result",
                              on: {
                                click: function ($event) {
                                  return _vm.goInterviewResult(props.row)
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.i18n("StatusBar.InterviewResult"))
                                ),
                              ]),
                              _c("div", { staticClass: "count" }, [
                                _vm._v(_vm._s(props.row.InterviewResultCount)),
                              ]),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "status appoint_result",
                              on: {
                                click: function ($event) {
                                  return _vm.goAppointResult(props.row)
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.i18n("StatusBar.AppointResult"))
                                ),
                              ]),
                              _c("div", { staticClass: "count" }, [
                                _vm._v(
                                  _vm._s(props.row.AppointmentResultCount)
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "progress-style" },
                            [
                              _c("el-progress", {
                                attrs: {
                                  type: "circle",
                                  percentage:
                                    Number(props.row.ProcessPercent) > 100
                                      ? 100
                                      : Number(props.row.ProcessPercent),
                                  "stroke-width": 12,
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "sizes,prev, pager, next,jumper, ->, total, slot",
              total: _vm.totalData,
              "page-size": 5,
              "page-sizes": [5, 10, 20, 50],
              "current-page": _vm.tableInfo.page,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.tableInfo, "page", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.tableInfo, "page", $event)
              },
              "current-change": _vm.handleCurrentChange,
              "size-change": _vm.handleSizeChange,
            },
          }),
        ],
        1
      ),
      _c("DemandDetailModal"),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "QRCodeModal", tabindex: "-1" },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "block",
                    "text-align": "center",
                    color: "#fff",
                    padding: "20px",
                  },
                },
                [_vm._v(" QR Code ")]
              ),
              _c(
                "div",
                { staticClass: "modal-body" },
                [
                  [
                    _c("qrcode-vue", {
                      staticClass: "qrcode-wrap",
                      attrs: { value: _vm.QRCode, size: _vm.size, level: "H" },
                    }),
                  ],
                  _c("div", { staticStyle: { "margin-top": "5px" } }, [
                    _vm.QRCode
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.QRCode,
                              expression: "QRCode",
                            },
                          ],
                          staticStyle: { opacity: "0" },
                          attrs: { id: "copyText", type: "text", size: "5" },
                          domProps: { value: _vm.QRCode },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.QRCode = $event.target.value
                            },
                          },
                        })
                      : _vm._e(),
                    _c("br"),
                    _c(
                      "button",
                      {
                        ref: "copyButton",
                        staticStyle: {
                          background: "inherit",
                          border: "none",
                          "margin-bottom": "25px",
                        },
                        attrs: { "data-clipboard-target": "#copyText" },
                        on: { click: _vm.initClipboard },
                      },
                      [
                        _c(
                          "span",
                          {
                            class: { copy_text: _vm.isCopy },
                            staticStyle: { color: "#fff" },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.i18n("Basic.CopyLink")) + " "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ],
                2
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }